import { useState } from "react";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { PiSealCheck } from "react-icons/pi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { InputField, Modal, TextComponent } from "../../../components";
import {
  sessionExpired,
  showAlert,
} from "../../../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { validateForm, validatePassword } from "../../../utills/Validators";
import styles from "./index.module.css";
import { getUser, isLogin } from "../../../Store/Actions/AuthAction";
import Storage from "../../../utills/AsyncStorage";

const ResetPassword = ({ open, setOpen }) => {
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [confirmPass, setConfirmPass] = useState("");
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const redirect_url = Storage.getRedirect_URL("@redirect_url");

  const formState = [
    { key: "Old Password", value: password },
    { key: "New Password", value: newPassword },
    { key: "Confirm Password", value: confirmPass },
  ];

  const onChangePassword = () => {
    let userdata = {
      password,
      newPassword,
      confirmPass,
      logout: 1,
    };
    const validation = validateForm(formState);
    if (!validation.isValid) {
      dispatch(
        showAlert({
          type: "Error",
          message: validation.message,
        }),
      );
    } else if (!validatePassword(newPassword)) {
      dispatch(
        showAlert({
          type: "warning",
          message:
            "Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.",
        }),
      );
      return;
    } else if (newPassword != confirmPass) {
      dispatch(
        showAlert({
          type: "warning",
          message: "Please make sure both passwords are identical.",
        }),
      );
      return;
    } else {
      dispatch(AuthMiddleware.resetPassword(userdata))
        .then(() => {
          setPassword("");
          setConfirmPass("");
          setNewPassword("");
          onPressSuccessBtn();
          // setIsSuccessFulModal(true);
        })
        .catch(() => {});
    }
  };

  const onPressSuccessBtn = () => {
    dispatch(AuthMiddleware.logout()).then((res) => {
      navigate(`${redirect_url}`);
      dispatch(getUser(null));
      dispatch(isLogin(false));
      dispatch(sessionExpired(false));
      // localStorage.clear();
    });
  };

  return (
    <div className={styles.mainCont}>
      <Modal
        width={"600px"}
        open={open}
        onCancel={setOpen}
        okBtnTitle={"Reset Password"}
        onBtnPress={onChangePassword}
        closable={false}
        buttonTitle={"Reset Password"}
      >
        <div className={styles.edit_mainCont}>
          <div className={styles.edit_heading}>
            <TextComponent
              text={"Reset Password"}
              style={{
                fontFamily: "Urbanist-bold",
                fontSize: "var(--heading2-font-size)",
              }}
            />
          </div>
          <InputField
            className={styles.input}
            label={"Old Password"}
            placeholder={"●●●●●●●●●●"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            rightIcon={
              passwordVisible ? (
                <LuEye size={20} color={"var(--input-icon)"} />
              ) : (
                <LuEyeOff size={20} color={"var(--input-icon)"} />
              )
            }
            onRightIconPress={() => setPasswordVisible(!passwordVisible)}
            type={passwordVisible ? "text" : "password"}
          />
          <InputField
            className={styles.input}
            label={"New Password"}
            placeholder={"●●●●●●●●●●"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            rightIcon={
              newPasswordVisible ? (
                <LuEye size={20} color={"var(--input-icon)"} />
              ) : (
                <LuEyeOff size={20} color={"var(--input-icon)"} />
              )
            }
            onRightIconPress={() => setNewPasswordVisible(!newPasswordVisible)}
            type={newPasswordVisible ? "text" : "password"}
          />
          <InputField
            className={styles.input}
            label={"Confirm New Password"}
            placeholder={"●●●●●●●●●●"}
            value={confirmPass}
            onChange={(e) => setConfirmPass(e.target.value)}
            rightIcon={
              confirmPassVisible ? (
                <LuEye size={20} color={"var(--input-icon)"} />
              ) : (
                <LuEyeOff size={20} color={"var(--input-icon)"} />
              )
            }
            onRightIconPress={() => setConfirmPassVisible(!confirmPassVisible)}
            type={confirmPassVisible ? "text" : "password"}
          />
        </div>
      </Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Password Changed Successfully!"}
        width={"400px"}
        buttonTitle={"Login to you Account"}
        onBtnPress={onPressSuccessBtn}
      ></Modal>
    </div>
  );
};

export default ResetPassword;
